var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelatedTagsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.748,
    height: 16.889,
    viewBox: "0 0 24.748 16.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "relatedTagsIcon",
    transform: "translate(-1145.758 -463.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11351",
    "data-name": "Path 11351",
    d: "M1169.006,477.735h-18.485v-9.051",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_706",
    "data-name": "Ellipse 706",
    cx: 4.263,
    cy: 4.263,
    r: 4.263,
    transform: "translate(1146.258 464.421)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5414",
    "data-name": "Rectangle 5414",
    width: 5.15,
    height: 5.15,
    transform: "translate(1155.784 475.16)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5414-2",
    "data-name": "Rectangle 5414",
    width: 5.15,
    height: 5.15,
    transform: "translate(1164.856 475.16)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedTagsIcon);
export default __webpack_public_path__ + "static/media/relatedTagsIcon.76c37d9b9add82fed7cf8d9b0080bf95.svg";
export { ForwardRef as ReactComponent };